// extracted by mini-css-extract-plugin
module.exports = {"header":"ManagementHeader_header__3-gDl","divider":"ManagementHeader_divider__1c1Lo"};